// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { SiOpenai as RawSiOpenai } from "react-icons/si";
export const SiOpenai = /* @__PURE__ */ createIcon(RawSiOpenai, "SiOpenai", 0);
